{
  "de": {
    "button": {
      "actions": {
        "add": "Hinzufügen",
        "back": "Zurück",
        "cancel": "Abbrechen",
        "close": "Schließen",
        "copyEmail": "E-Mail kopieren",
        "create": "Erstellen",
        "delete": "Löschen",
        "display": "Anzeigen",
        "edit": "Bearbeiten",
        "hide": "Ausblenden",
        "loading": "Wird geladen",
        "more": "Weitere Aktionen",
        "move": "Verschieben",
        "move_down": "Nach unten verschieben",
        "move_up": "Nach oben verschieben",
        "no": "Nein",
        "reactivateEmailAddress": "E-Mail-Adresse reaktivieren",
        "reset": "Zurücksetzen",
        "save": "Speichern",
        "save_changes": "Änderungen speichern",
        "save_message": "Nachricht speichern",
        "saving": "Wird gespeichert",
        "share": "Teilen",
        "startTour": "Tour starten",
        "uploadingDocuments": "Dokumente werden hochgeladen",
        "yes": "Ja"
      }
    }
  }
}
